// Shared colour-band helpers. See "Duplicate frontend formatting and colour
// helpers.md" (Tech Debt 2026-09 audit) for the finding.
//
// winRateColor had drifted to 3 different band tables (Assessment.js,
// Historic.js, DteRecommendation.js). Assessment.js's is the most-used
// (9 call sites) and wins here; Historic.js and DteRecommendation.js are
// repointed at it, which visibly changes their band edges (was 75/65/55 in
// both, now 90/80/70) -- called out in the ticket commit, not silent.
//
// NOT consolidated here (left in place, on purpose): rtrColor is duplicated
// in Assessment.js (>20/>0/>-20) and DteRecommendation.js (>30/>10/>0) with
// genuinely different breakpoints, not just a formatting difference -- which
// one is "right" is an owner call, not a cleanup call.
export function winRateColor(v) {
  if (v == null) return 'text-gray-600';
  if (v >= 90) return 'text-trading-green-300 font-semibold';
  if (v >= 80) return 'text-trading-green-400 font-medium';
  if (v >= 70) return 'text-trading-green-400';
  return 'text-amber-300';
}
